export default "__VITE_ASSET__bed4ff9b__"